export default {
  "autresServices": {
    "heroTitle": "其他技术服务",
    "heroSubtitle": "凭借我们多学科的技术专长，为您提供从始至终的全方位配套服务",
    "intro": "除了我们的能源解决方案，IS TELECOM还为您提供全面的技术服务，确保您的项目成功。",
    "prestationsLabel": "我们的服务：",
    "subServicesLabel": "相关服务：",
    "ctaLink": "讨论您的项目",
    "whyUs": {
      "title": "为什么选择我们的技术服务？",
      "items": [
        {"title": "公认的认证", "desc": "我们的团队通过了最严格的国际标准认证（ISO、CE、TUV）。"},
        {"title": "多学科团队", "desc": "工程师、技术人员、建筑师和顾问齐聚一堂，覆盖您项目的各个方面。"},
        {"title": "质量保证", "desc": "每项服务都经过检查、验证和保证。我们只交付符合我们标准的产品。"}
      ]
    },
    "cta": {
      "title": "复杂的项目？我们有解决方案。",
      "subtitle": "无论您的技术需求是什么，我们的多学科团队都能找到合适的答案。",
      "button": "与专家交流"
    },
    "services": [
      {
        "id": "audit",
        "title": "审计与咨询",
        "fullDesc": "我们的专家团队执行全面的能源审计，分析您现有的安装并确定优化领域。每项建议都针对您项目的具体需求量身定制。",
        "details": ["现场完整能源诊断", "历史消耗分析", "技术和经济可行性研究", "带估算投资回报率的个性化建议", "协助寻求融资"]
      },
      {
        "id": "expertise",
        "title": "技术专长",
        "fullDesc": "我们的技术专家介入以验证您安装的合规性，认证性能并提出优化方案。我们保证您能源系统的安全性、可靠性和性能。",
        "details": ["司法和技术鉴定", "现有安装的认证", "能源性能优化", "法规合规性验证", "详细的专家报告"]
      },
      {
        "id": "informatique",
        "title": "信息技术",
        "fullDesc": "我们部署完整的信息技术基础设施以支持您的能源项目：网络、服务器、监控系统、能源管理平台和网络安全解决方案。",
        "details": ["局域网和广域网部署", "服务器和数据中心配置", "能源监控平台", "信息安全和网络安全", "技术支持和IT维护"]
      },
      {
        "id": "environnement",
        "title": "环境服务",
        "fullDesc": "我们支持您的项目在环境合规方面：影响研究、碳足迹、生态认证和可持续发展咨询。",
        "details": ["环境影响研究（EIA）", "碳足迹和减排战略", "环境认证（LEED、BREEAM）", "循环经济咨询", "电子废物管理"]
      },
      {
        "id": "btp",
        "title": "金属结构与土木工程",
        "fullDesc": "我们的土木工程和金属结构部门为您的能源项目制造和安装定制结构：框架、面板支架、技术建筑和土木工程基础设施。",
        "details": ["定制金属结构制造", "土木工程和专业基础", "技术建筑和变电站建设", "围栏安装和场地安全", "翻新和扩建工程"]
      },
      {
        "id": "telecom",
        "title": "电信",
        "fullDesc": "IS TELECOM部署完整的电信基础设施：塔架和电线杆安装、光纤和无线网络部署、无线电设备维护以及农村和城市地区的连接解决方案。",
        "details": ["电信塔架和电线杆安装", "光纤和无线网络部署", "无线电设备预防性和纠正性维护", "偏远农村地区的连接解决方案", "与现有太阳能基础设施的集成"]
      },
      {
        "id": "transport",
        "title": "运输与物流",
        "fullDesc": "我们负责您在非洲及更远地区的能源和电信设备的运输和物流。从专业搬运到现场交钥匙交付，我们保证您货物运输的安全性和及时性。",
        "details": ["重型设备的公路和海运", "太阳能板和电池的专业搬运", "项目物流和供应链", "海关和货物运输行政管理", "偏远地点的交钥匙交付"],
        "subServices": [
          {
            "id": "location",
            "title": "工程机械租赁",
            "desc": "我们为您的工地提供重型机械和专用设备租赁服务：起重机、高空作业平台、推土机、挖掘机、压路机和自卸卡车。我们的设备定期维护，可根据您的需求配备或不配备合格操作员。",
            "details": ["移动式和塔式起重机租赁", "高空作业平台和伸缩臂叉装车", "土方设备：推土机、挖掘机、平地机", "压路机、碾压机和摊铺机", "自卸卡车和物料运输车辆", "短期或长期合同，配备或不配备操作员"]
          }
        ]
      }
    ]
  }
};